// extracted by mini-css-extract-plugin
module.exports = {"list":"data-list_list__y6mat","show":"data-list_show___NPUJ","item":"data-list_item__bn65A","active":"data-list_active__CFa0V","empty":"data-list_empty__6Nj1D"};